import { render, staticRenderFns } from "./BoardsError.vue?vue&type=template&id=49986b86&scoped=true"
import script from "./BoardsError.vue?vue&type=script&lang=js"
export * from "./BoardsError.vue?vue&type=script&lang=js"
import style0 from "./BoardsError.vue?vue&type=style&index=0&id=49986b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49986b86",
  null
  
)

export default component.exports